import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23f1a182"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "middle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_SwipeItem = _resolveComponent("SwipeItem")!
  const _component_Swipe = _resolveComponent("Swipe")!
  const _component_Empty = _resolveComponent("Empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Swipe, {
        class: "my-swipe",
        autoplay: 3000,
        "indicator-color": "white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SwipeItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_image, {
                style: {"width":"95%","margin":"0 10px"},
                height: "170",
                radius: "5",
                fit: "cover",
                src: _ctx.bannerImg1
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_SwipeItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_image, {
                style: {"width":"95%","margin":"0 10px"},
                height: "170",
                radius: "5",
                fit: "cover",
                src: _ctx.bannerImg2
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_SwipeItem, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_image, {
                style: {"width":"95%","margin":"0 10px"},
                height: "170",
                radius: "5",
                fit: "cover",
                src: _ctx.bannerImg3
              }, null, 8, ["src"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Empty, {
        description: "敬请期待",
        "image-size": "180"
      })
    ]),
    _hoisted_4
  ]))
}